import React, { Component } from "react";
import { Popover, Icon, message, DatePicker, Input, Button, Form, Table } from "antd";
import { auth } from '../firebase';
import "../App.css";
import { db, storr } from '../firebase/firebase';


const { TextArea } = Input;
//=================editable==========================
const FormItem = Form.Item;
const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form}>
    <tr {...props} />
  </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);
//=================editable==========================

class EditableCell extends React.Component {
  getInput = () => {
    if (this.props.inputType === 'areaa') {
      return <TextArea autosize />;
    } else
      return <Input />;
  };

  render() {
    const {
      editing,
      dataIndex,
      title,
      inputType,
      record,
      index,
      ...restProps
    } = this.props;
    return (
      <EditableContext.Consumer>
        {(form) => {
          const { getFieldDecorator } = form;
          return (
            <td {...restProps}>
              {editing ? (
                <FormItem style={{ margin: 0 }}>
                  {getFieldDecorator(dataIndex, {
                    rules: [{
                      required: false,
                      message: `Please Input ${title}!`,
                    }],
                    initialValue: record[dataIndex],
                  })(this.getInput())}
                </FormItem>
              ) : restProps.children}
            </td>
          );
        }}
      </EditableContext.Consumer>
    );
  }
}

export class News extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pendingMedia: "",
      pendingData: { title: "", desc: "", date: "2019-01-01", disabled: true, inputDisabled: false },
      data: [],
      show: false,
    };

    this.columns = [
      {
        title: 'Date',
        dataIndex: 'date',
        width: '12%',
        ...this.getColumnSearchProps('date'),
        editable: true,
        sorter: (a, b) => { return a.date.localeCompare(b.date) },
        render: (text, record) => {
          const editable = this.isEditing(record);
          return (
            <div>
              {text}
            </div>
          );
        },
      },
      {
        title: 'Title',
        dataIndex: 'title',
        ...this.getColumnSearchProps('title'),
        inputType: 'areab',
        editable: true,
        sorter: (a, b) => { return a.title.localeCompare(b.title) },
      },
      {
        title: 'Description',
        dataIndex: 'desc',
        ...this.getColumnSearchProps('desc'),
        sorter: (a, b) => { return a.desc.localeCompare(b.desc) },
        inputType: 'areab',
        editable: true,
        // render: (text, record) => {
        //   const editable = this.isEditing(record);
        //   return (
        //     <div>
        //       {text}
        //     </div>
        //   );
        // },
      },
      {
        title: 'Image',
        dataIndex: 'image',
        editable: false,
        render: (text, record) => {
          const editable = this.isEditing(record);
          return (
            <div>
              {editable ? (
                <div className="btn4">
                  <div className="upload-btn-wrapper">
                    <button className="btn2">Upload an Image</button>
                    <input type="file"
                      accept="image/png, image/jpeg"
                      onChange={this.handlefile(record.key)}
                    />
                  </div>
                  <div className="btn3"><Button type='danger' onClick={() => this.deleteImg(record.key)}>Delete Image</Button></div>
                </div>
              ) : (
                  <div>
                    <a href={record.image} target="_blank"><img src={record.image} alt={record.image} height="100">
                    </img></a>
                  </div>
                )}
            </div>
          );
        },
      },
      {
        title: '',
        dataIndex: 'operation',
        width: '15%',
        render: (text, record) => {
          const editable = this.isEditing(record);

          return (
            <div>
              {editable ? (
                <span>
                  <EditableContext.Consumer>
                    {form => (
                      <Button
                        onClick={() => this.save(form, record.key)}
                        style={{ marginRight: 8 }}
                      >
                        Save
                      </Button>
                    )}
                  </EditableContext.Consumer>
                  <Button
                    type='primary'
                    onClick={() => this.cancel(record.key)}
                  >
                    Cancel
                      </Button>

                </span>
              ) : (
                  <div>
                    <Button
                      type='primary'
                      onClick={() => this.restore(record.key)}
                      style={{ marginRight: 8 }}
                    >
                      Restore
                </Button>
                    <Button
                      type='danger'
                      onClick={() => this.deleteProject(record.key)}
                    >
                      <Icon type="delete" />
                            </Button>
                  </div>
                )}
            </div>
          );
        },
      },
    ];

    this.deleteProject = this.deleteProject.bind(this);
    this.deleteImg = this.deleteImg.bind(this);
    this.addProject = this.addProject.bind(this);

    this.pullFromDB();

    auth.onAuthStateChanged((user) => {
      if (user) {
        this.setState({ email: user.email })
      }
    });

  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys, selectedKeys, confirm, clearFilters,
    }) => (
        <div style={{ padding: 8 }}>
          <Input
            ref={node => { this.searchInput = node; }}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm)}
            icon="search"
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
        </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
        </Button>
        </div>
      ),
    filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      text
    ),
  })

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  }

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: '' });
  }

  async deleteProject(ppd) {
    var idpath = this.state.data[ppd].id
    var imgpath = this.state.data[ppd].id + this.state.data[ppd].ext

    await db
      .collection("news")
      .doc(this.state.data[ppd].id)
      .delete().then(function () {
        message.success("Row " + idpath + " deleted successfully")
        var ref = storr.ref(imgpath);

        ref.getMetadata().then(function (metadata) {
          ref.delete().then(function () {
            message.success("File " + imgpath + " deleted successfully")
          }).catch(function (error) {
            message.error("Uh-oh, an error occurred! " + error.message)
          });
        }).catch(function (error) {
          // message.error("Uh-oh, an error occurred! " + error.message)
        });

      }).catch(function (error) {
        message.error(error.message)
      });
  }



  handlePreuploadFile = (event) => {
    var abb = this.state.pendingData;

    abb.file = event.target.files[0]

    if (this.fileCheckIsOK(abb.file)) {
      message.info("You inputed " + event.target.files[0].name)
      abb.file = event.target.files[0]
    } else {
      document.getElementById("uploadCaptureInputFile").value = ""
      abb.file = null
    }

    this.setState({ pendingData: abb });
  }
  handlefile = (key) => (event) => {
    console.log('Parameter', this.state.data[key].id);
    if (this.fileCheckIsOK(event.target.files[0])) {
      message.loading('Uploading...')

      var tempFile = event.target.files[0]

      var ext = tempFile.name.substring(tempFile.name.lastIndexOf('.'), tempFile.name.length)

      // Create a reference with an initial file path and name
      var jayjay = this.state.data[key].id;

      var ref = storr.ref(this.state.data[key].id + ext);
      // Get the download URL

      // Upload file and metadata to the object 'images/mountains.jpg'
      var uploadTask = storr.ref(this.state.data[key].id + ext).put(event.target.files[0]).then(function (doc) {

        ref.getDownloadURL().then(function (url) {
          // console.log("putting link into database " + url)

          // Insert url into an <img> tag to "download"
          //open the link of the url.
          // window.open(url, '_blank');
          db.collection("news").doc(jayjay).update({
            ext: ext,
            image: url
          })
          message.destroy()
          message.success("Uploaded successfully")
        })

      });

    }
  }

  restore = (ppd) => {
    var idpath = this.state.data[ppd].id

    db.collection("news").doc(idpath).update({
      archived: false
    })
      .then(function () {
        message.success("Document " + idpath + " successfully restored!");
      })
      .catch(function (error) {
        // The document probably doesn't exist.
        message.error(error.message)
      });
  }

  async deleteImg(pid) {
    var pathy = this.state.data[pid].id + this.state.data[pid].ext;
    var ref = storr.ref(pathy);
    // Get the download URL
    ref.delete().then(function () {
      message.success("File deleted successfully")
    }).catch(function (error) {
      if (error.message.includes('Firebase Storage: Object '))
        message.error(error.message.replace('Firebase Storage: Object ', ''))
      else
        message.error(error.message)
    });

    await db.collection("news").doc(this.state.data[pid].id).update({
      image: ""
    })
  }

  pullFromDB() {
    // We listen for live changes to our events collection in Firebase
    db.collection("news").where('archived', '==', true).onSnapshot(snapshot => {
      let data = [];
      snapshot.forEach(doc => {
        const todo = doc.data();
        todo.id = doc.id;
        data.push(todo);
      });
      //sort by timestamp
      data.sort((a, b) => (a.timestamp > b.timestamp) ? -1 : 1)

      //assign key for edit function to work properly
      for (var i = 0; i < data.length; i++) {
        data[i].key = i;
      }

      // Anytime the state of our database changes, we update state
      this.setState({ data });

    })
  }

  fileCheckIsOK = (f) => {
    if (f) {
      if (f.type === 'image/png' || f.type === 'image/jpeg') {
        console.log("accepted file format")
        if (f.size < 100000000) {
          return true
        } else {
          message.error('File too big')
          return false
        }
      } else {
        message.error('Unaccepted file type')
        return false
      }
    } else {
      return false
    }
  }

  uploadThenAddToDatabase = (ahh) => {
    message.loading('Uploading...')

    var docy = db.collection("news").doc()

    var ext = ahh.file.name.substring(ahh.file.name.lastIndexOf('.'), ahh.file.name.length)

    var ref = storr.ref(docy.id + ext);

    var self = this

    // Upload file and metadata to the object 'images/mountains.jpg'
    storr.ref(docy.id + ext).put(ahh.file).then(function (doc) {

      ref.getDownloadURL().then((url) => {
        docy.set({
          title: ahh.title,
          date: ahh.date,
          image: url,
          ext: ext,
          desc: ahh.desc,
          timestamp: Date.now()
        })
        document.getElementById("uploadCaptureInputFile").value = ""
        ahh.file = null
        ahh.title = ""
        ahh.desc = ""
        ahh.inputDisabled = false
        self.setState({ pendingData: ahh })
        message.destroy()
        message.success("Uploaded successfully")
      })

    });
  }

  async addProject() {
    var ayy = this.state.pendingData
    ayy.disabled = true
    ayy.inputDisabled = true
    this.setState({ pendingData: ayy })

    if (this.state.pendingData.file != null) {
      this.uploadThenAddToDatabase(this.state.pendingData)
    } else {
      await db.collection("news").add({
        title: this.state.pendingData.title,
        date: this.state.pendingData.date,
        image: '',
        desc: this.state.pendingData.desc,
        timestamp: Date.now()
      }).then((a) => {
        ayy.title = ""
        ayy.desc = ""
        ayy.inputDisabled = false
        this.setState({ pendingData: ayy })
        message.destroy()
        message.success("News added successfully")
      })
    }

  }

  isEditing = (record) => {
    return record.key === this.state.editingKey;
  };

  edit(key) {
    this.setState({ editingKey: key });
    this.state.show = true
  }

  save(form, key) {
    this.state.show = false
    form.validateFields((error, row) => {
      if (error) {
        return;
      }
      const newData = [...this.state.data];
      const index = newData.findIndex(item => key === item.key);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, {
          ...item,
          ...row,
        });

        var daysInMonth = function (m, y) {
          switch (m) {
            case 1:
              return (y % 4 == 0 && y % 100) || y % 400 == 0 ? 29 : 28;
            case 8: case 3: case 5: case 10:
              return 30;
            default:
              return 31
          }
        };
        var isValidDate = function () {
          var d = newData[index].date.substring(8)
          // console.log("day", d)
          var m = newData[index].date.substring(5, 7)
          // console.log("month", m)
          var y = newData[index].date.substring(0, 4)
          // console.log("year", y)

          m = parseInt(m, 10) - 1;
          return m >= 0 && m < 12 && d > 0 && d <= daysInMonth(m, y);
        };

        if (!/^\d{4}-\d{2}-\d{2}$/.test(newData[index].date)) {
          message.error("Please use 'YYYY-MM-DD' format only")
        } else if (!isValidDate()) {
          message.error("Not a valid date")
        } else {
          db
            .collection("news")
            .doc(this.state.data[index].id).update({
              title: newData[index].title,
              desc: newData[index].desc,
              date: newData[index].date,
            })
            .then(() => {
              message.destroy()
              message.success("Document successfully updated!");
              this.setState({ data: newData, editingKey: '' });
            })
            .catch(function (error) {
              // The document probably doesn't exist.
              message.destroy()
              message.error("Error updating document: " + error.message);
            });
        }

      } else {
        newData.push(row);
        this.setState({ data: newData, editingKey: '' });
      }
    });
  }

  cancel = () => {
    this.setState({ editingKey: '' });
    this.state.show = false
  };

  descChange = (v) => {
    var vvv = this.state.pendingData;
    vvv.desc = v.target.value
    this.setState({ pendingData: vvv });
  }

  titleChange = (v) => {
    var vvv = this.state.pendingData;
    vvv.title = v.target.value
    if (vvv.title.length > 1)
      vvv.disabled = false
    else
      vvv.disabled = true
    this.setState({ pendingData: vvv });
  }

  dateChange = (date, dateString) => {
    var ndd = this.state.pendingData;

    ndd.date = dateString
    this.setState({ pendingData: ndd });
  }

  clearInputFile = () => {
    var tempB = this.state.pendingData
    document.getElementById("uploadCaptureInputFile").value = ""
    tempB.file = null
    this.setState({ pendingData: tempB })
  }

  render() {
    // console.log(this.state.email)
    const components = {
      body: {
        row: EditableFormRow,
        cell: EditableCell,
      },
    };

    const columns = this.columns.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: record => ({
          record,
          inputType: col.inputType === 'areab' ? 'areaa' : 'text',
          dataIndex: col.dataIndex,
          title: col.desc,
          editing: this.isEditing(record),
        }),
      };
    });
    return (
      <div>
        <h1 className="block">Archived News</h1>

        {this.state.email == 'cc@cc.cc' ? <div>debug</div> : <div />}

        <Table
          components={components}
          bordered
          pagination={{ pageSize: 15 }}
          dataSource={this.state.data}
          columns={columns}
          rowClassName="editable-row"
        />
      </div>
    )
  }

}
export default News;



// WEBPACK FOOTER //
// ./src/views/anews.js